import { render, staticRenderFns } from "./JourneysList.vue?vue&type=template&id=03a1c185&scoped=true&"
import script from "./JourneysList.vue?vue&type=script&lang=js&"
export * from "./JourneysList.vue?vue&type=script&lang=js&"
import style0 from "./JourneysList.vue?vue&type=style&index=0&id=03a1c185&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a1c185",
  null
  
)

/* custom blocks */
import block0 from "./JourneysList.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports